import React from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'src/shared/themeContext'
import { pStyle, smallPStyle } from 'src/constants/fontStyles'

type LinkProps = {
  size?: 'small'
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

const Link = ({ size, children, ...props }: LinkProps) => {
  const {
    brand: { primary },
  } = useTheme()

  const StyledLink = styled.a`
    ${size === 'small' ? smallPStyle : pStyle};
    color: ${primary.default};
    user-select: none;

    &:hover {
      color: ${primary.default};
      text-decoration: underline;
    }
  `
  return <StyledLink {...props}>{children}</StyledLink>
}
export default Link
